<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'users'}">
              Users
            </router-link>
          </li>
          <li class="active">
            <a href="#">Edit user</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content user-content">
        <div
          class="box"
          v-loading="loading"
        >
          <div class="box-body">
            <el-form
              :model="user"
              :rules="rules"
              ref="user"
              label-width="120px"
              label-position="top"
            >
              <el-form-item
                label="Name"
                prop="name"
              >
                <el-input v-model="user.name"></el-input>
              </el-form-item>
              <el-form-item
                label="Email"
                prop="email"
              >
                <el-input v-model="user.email"></el-input>
              </el-form-item>
              <el-form-item
                label="Password"
                prop="password"
              >
                <el-input
                  v-model="user.password"
                  placeholder="Leave blank if the password should be the same"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Role"
                prop="role"
              >
                <el-select
                  v-model="user.role"
                  placeholder="Please select user role"
                >
                  <el-option
                    v-for="item in roles"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="Customer"
                prop="customerId"
              >
                <el-select
                  v-model="user.customerId"
                  placeholder="Please select customer"
                >
                  <el-option
                    v-for="item in customers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('user')"
                >Save</el-button>
                <el-button @click="resetForm('user')">Reset</el-button>
              </el-form-item>
            </el-form>
            <hr>

          </div>
          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'user-edit',
  props: {
    id: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      user: {
        name: '',
        email: '',
        role: '',
        customerId: undefined,
        password: ''
      },
      rules: {
        name: [
          { required: true, message: 'Please input user name', trigger: 'blur' },
          { min: 3, message: 'Length should be more then 3', trigger: 'blur' }
        ],
        email: [
          {
            type: 'email',
            message: 'Please input user email',
            required: true,
            trigger: 'blur'
          }
        ],
        role: [
          {
            type: 'string',
            message: 'Please select user role',
            required: true,
            trigger: 'blur'
          }
        ],
        customerId: [
          {
            type: 'number',
            message: 'Please select user customer',
            required: true,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      roles: 'users/roles',
      customers: 'customers/list'
    })
  },
  mounted () {
    this.loading = true
    Promise.all([
      this.getUser(this.id),
      this.fetchRoles(),
      this.fetchCustomers()
    ])
      .then(resp => {
        this.loading = false
        this.user = resp[0].data
      }).catch(_ => {
        this.loading = false
        this.$router.push({ name: '404' })
      })
  },
  methods: {
    ...mapActions('users', ['saveUser', 'getUser', 'fetchRoles']),
    ...mapActions('customers', ['fetchCustomers']),
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { name, role, email, customerId, password } = this.user
          this.loading = true
          this.saveUser({ id: this.id, user: { name, role, email, customerId, password } })
            .then(_ => this.$router.push({ name: 'users' }))
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// Edit.vue?a6c51e84